<template>
	<div :class="{ 'red-table-header': IsRed, 'blue-table-header': IsBlue}">
		<div class="level" v-if="!RemoveLevel">
			<div class="level-left" v-if="Select">
				<b-button :class="checkedRows.length == 0 ? 'is-secondary' : 'is-primary'" v-if="!ForChart" :disabled="checkedRows.length == 0" @click="addSelected">Add {{checkedRows.length}} aircraft to portfolio</b-button>&nbsp;
				<b-button :class="checkedRows.length == 0 ? 'is-secondary' : 'is-primary'" v-if="ForChart" :disabled="checkedRows.length == 0 || checkedRows.length > 50" @click="addSelected">Select {{checkedRows.length}} aircraft for charting</b-button>
				<b-button class="is-secondary" style="margin-left: 5px;" v-if="DeleteSelected" :disabled="checkedRows.length == 0" @click="deleteSelected">Delete selected aircraft</b-button>
			</div>
			<div class="level-right">
				<div class="level-item" v-if="!HideNumber">
					<span v-if="Aircraft">{{ Aircraft.length || 0 }} aircraft entities</span>
				</div>
				<div class="level-item" v-if="Create">
					<b-button icon-left="plane" class="is-primary" @click="createAircraft">Create Aircraft</b-button>
				</div>
			</div>
		</div>
		<b-table :data="Aircraft"
				 :checked-rows.sync="checkedRows"
				 :checkable="Select"
				 :paginated="Paginated"
				 per-page="20"
				 hoverable
				 mobile-cards
				 :loading="IsLoading"
				 :default-sort="DefaultSort"
				 :row-class="RowClass"
				 default-sort-direction="asc">
			<template slot="empty">
				<p>No aircraft for this account</p>
			</template>
			<b-table-column v-if="Name" field="Name" label="Name" v-slot="props" sortable>
				<span v-if="HideEdit">{{ props.row.Name }}</span>
				<a v-if="!HideEdit" @click="manageAircraft(props.row)">{{ props.row.Name }}</a>
			</b-table-column>
			<b-table-column v-if="Model" field="ModelName" label="Aircraft model" v-slot="props" sortable>
				{{ props.row.Manufacturer ? props.row.Manufacturer: '' }} {{ props.row.ModelName }}
			</b-table-column>
			<b-table-column v-if="Type" field="Type" label="Type" v-slot="props" sortable>
				{{ props.row.Type }}
			</b-table-column>
			<b-table-column field="Quantity" label="Quantity" v-slot="props" width="25" numeric sortable>
				{{ props.row.Quantity }}
			</b-table-column>
			<b-table-column field="FlightHours" label="Average flight hours" v-slot="props" numeric sortable>
				{{ props.row.FlightHours }}
			</b-table-column>
			<b-table-column field="Cycles" label="Average cycles" v-slot="props" numeric sortable>
				{{ props.row.Cycles }}
			</b-table-column>
			<b-table-column field="CarbonOutput" width="230" label="Aggregate annual C02 emissions (tonnes)" v-slot="props" numeric sortable>
				{{ $math.format($math.round(props.row.CarbonOutput, 3)) }}
			</b-table-column>
			<b-table-column v-if="Manage" label="Actions" width="180" v-slot="props">
				<span><a @click="manageAircraft(props.row)">{{ HasPath('/portfolio/manage') ? 'Edit': 'Manage' }}</a> | <a @click="deleteOrRemove(props.row.Id)">{{ HasPath('/portfolio/manage') ? 'Remove': 'Delete' }}</a></span>
			</b-table-column>
			<b-table-column v-if="Report" label="Report" v-slot="props">
				<span><a>View</a></span>
			</b-table-column>
			<b-table-column v-if="Download" label="Certificate" v-slot="props">
				<aircraftCertificate @complete="setDownloading(props.row, false)" :aircraft="props.row"></aircraftCertificate>
				<div v-if="false">
					<b-button class="is-default is-small" :loading="props.row.downloading" :disabled="props.row.downloading" @click="download(props.row)">Download</b-button>
					<div v-if="props.row.downloading" :key="props.row.Id">
						<aircraftCertificate @complete="setDownloading(props.row, false)" :aircraft="props.row"></aircraftCertificate>
					</div>
				</div>
			</b-table-column>
		</b-table>
	</div>
</template>

<script>
	import aircraftCertificate from "@/components/certificates/aircraftCertificate.vue";
	import SaveAircraft from "@/components/modals/addAircraft/createNew.vue";

	export default {
		components: {
			aircraftCertificate: aircraftCertificate,

		},
		data() {
			return {
				checkedRows: [],
			}
		},
		props: {
			Aircraft: Array,
			Create: Boolean,
			RemoveLevel: Boolean,
			Name: Boolean,
			Model: Boolean,
			Type: Boolean,
			Manage: Boolean,
			Report: Boolean,
			Download: Boolean,
			Paginated: Boolean,
			Select: Boolean,
			IsRed: Boolean,
			IsBlue: Boolean,
			IsLoading: Boolean,
			HideNumber: Boolean,
			ConfirmDelete: String,
			OnDelete: Function,
			ForChart: Boolean,
			HideEdit: Boolean,
			DeleteSelected: Boolean
		},
		computed: {
			DefaultSort() {
				if (this.Name)
					return ["Name", "asc"];
				else if (this.Model)
					return ["ModelName", "asc"];
				else if (this.Type)
					return ["Type", "asc"];
				else
					return undefined;
			}
		},
		watch: {
			Aircraft: {
				handler(n, o) {
					if (!n)
						return;
					else if (n && o) {
						//We assume there exists a key "Id" property on each row to fix this bug.
						//If we ever put data that does not include "Id" we will need to include a prop to specify the Id to use in vm.'props'.
						var carryOver = n.filter(x => this.checkedRows.some(y => x.Id == y.Id));
						this.$set(this, 'checkedRows', carryOver);
					}
				}
			}
		},
		methods: {
			RowClass(row, i) {
				var css = ["bgcolor-transition"];
				if (row.modified == true) {
					css.push("is-highlighted");
					if (!row._timeout) {
						row._timeout = setTimeout(() => {
							this.$set(row, "modified", false);
							delete row._timeout;
						}, 5000);
					}
				}
				return css.join(" ");
			},
			HasPath(path) {
				if (this.$route.path.indexOf(path) > -1)
					return true;
				else
					return false;
			},
			addSelected() {
				this.$emit('addSelected', this.checkedRows.map(x => x.Id));
			},
			clearSelected() {
				this.checkedRows = [];
			},
			download(row) {
				this.setDownloading(row, true);
			},
			setDownloading(row, downloading) {
				this.$set(row, 'downloading', downloading);
			},
			deleteOrRemove(Id) {
				this.$buefy.dialog.confirm({
					message: this.ConfirmDelete || 'Are you sure you want to delete this aircraft?',
					onConfirm: async () => {
						var response = await this.OnDelete(Id);
						if (response.data == true) {
							const i = this.Aircraft.map(x => x.Id).indexOf(Id);
							this.$emit('afterDelete', i);
						}
						else {
							this.$emit('afterDelete', -1);
						}
					}
				});
			},
			deleteSelected() {
				var ids = this.checkedRows.map(x => x.Id);
				this.$emit("bulkDelete", ids);
			},
			manageAircraft(aircraft) {
				this.$buefy.modal.open({
					parent: this,
					component: SaveAircraft,
					hasModalCard: true,
					props: {
						Aircraft: aircraft
					},
					events: {
						'refreshManage': () => {
							this.$emit('refreshManage');
						},
						'onSuccess': (aircraft) => {
							aircraft.modified = true;
							const i = this.Aircraft.map(x => x.Id).indexOf(aircraft.Id);
							const response = { aircraft: aircraft, index: i };
							this.$emit('refresh', response);
						},
						'createNew': () => {
							this.createAircraft();
						}
					}
				})
			},
			createAircraft() {
				this.$buefy.modal.open({
					parent: this,
					component: SaveAircraft,
					hasModalCard: true,
					events: {
						'close': () => {
							//this.$emit('refresh');
						},
						'onSuccess': (aircraft) => {
							aircraft.modified = true;
							const i = this.Aircraft.map(x => x.Id).indexOf(aircraft.Id);
							const response = { aircraft: aircraft, index: i };
							this.$emit('refresh', response);
						},
						'createNew': () => {
							this.createAircraft();
						}
					}
				})
			}
		}
	}
</script>
